export default "/images/btn-ask.svg?9e083305143fbc6bc598f435997aaea7";